import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const address = "http://www.autokolarovic.cz/adm/api";

export const store = new Vuex.Store({
  state: {
    carsForSale: [],
    carDetail: null,
    backdropVisible: false,
    mobileMenuVisible: false,
    carsLoading: false,
    carDetailLoading: false
  },
  getters: {
    getCars: state => {
      return state.carsForSale;
    },
    showBackdrop: state => {
      return state.backdropVisible;
    },
    showMobileMenu: state => {
      return state.mobileMenuVisible;
    },
    isCarsLoading: state => {
      return state.carsLoading;
    },
    isCarDetailLoading: state => {
      return state.carDetailLoading;
    },
    getDetail(state) {
      return state.carDetail;
    }
  },
  mutations: {
    changeMobileMenuVisibility: state => {
      state.mobileMenuVisible = !state.mobileMenuVisible;
      if (!state.mobileMenuVisible) {
        setInterval(() => {
          state.backdropVisible = state.mobileMenuVisible;
        }, 400);
      } else {
        state.backdropVisible = state.mobileMenuVisible;
      }
    },
    changeCarsLoading: state => {
      state.carsLoading = !state.carsLoading;
    },
    setCarLoading(state, isLoading) {
      state.carDetailLoading = isLoading;
    },
    clearCarDetail(state) {
      state.carDetail = null;
    },
    changeCarDetail(state, data) {
      state.carDetail = data;
      state.carDetailLoading = false;
    },
    getCars(state, data) {
      state.carsForSale = data;
    }
  },
  actions: {
    getCars(state) {
      state.commit("changeCarsLoading");
      axios
        .get(address + "/CarsList")
        .then(res => {
          state.commit("getCars", [...res.data]);
          state.commit("changeCarsLoading");
        })
        .catch(() => {
          state.commit("changeCarsLoading");
        });
    },
    getCar(state, id) {
      state.commit("clearCarDetail");
      state.commit("setCarLoading", true);
      axios
        .get(address + "/CarDetail/" + id)
        .then(res => {
          state.commit("changeCarDetail", res.data);
        })
        .catch(() => {
          state.commit("setCarLoading", false);
          // console.log(err);
        });
    },
    sendEmail(state, data) {
      if (data != null && data.test == null && data.text != null) {
        axios
          .post(address + "/SendEmail/", data)
          .then(() => {
            // console.log(res);
          })
          .catch(() => {});
      }
    }
  }
});
